<template>
  <ToastProvider>
    <!--
      ToastViewport is where the toasts get portalled to, but ToastViewport
      isn't portalling them to body.
    -->
    <Teleport to="body">
      <ToastViewport :class="$style.viewport" />
    </Teleport>

    <!-- Toasts from `showToast` are rendered here -->
    <Toast v-for="toast in toasts" :key="toast.id" :toast="toast" />
  </ToastProvider>
</template>

<script setup lang="ts">
import { ToastProvider, ToastViewport } from "reka-ui";

import Toast from "@/design_system/Toast.vue";
import { UNSTABLE_toasts as toasts } from "@/lib/toasts";
</script>

<style module>
.viewport {
  --viewport-padding: 24px;
  @apply fixed bottom-0 right-0;
  @apply flex flex-col gap-3;
  @apply m-0;
  padding: var(--viewport-padding);
  padding-bottom: calc(var(--viewport-padding) + env(safe-area-inset-bottom));
  width: 400px;
  max-width: 100vw;
  list-style: none;
  z-index: var(--z-toast);
  outline: none;

  /**
   * <ToastViewport> sets `pointer-events: none` when there are no toast,
   * and unsets it when there are.
   *
   * <Dialog> sets `pointer-events: none` on the <body> and `all` it for
   * its own elements, this means that the <Toast> will remain inoperable
   * despite its z-index being higher.
   *
   * we can counteract that by <ToastViewport> always setting a pointer-events.
   */
  &:not(&:empty) {
    pointer-events: all;
  }
}
</style>
